import { normalizeLiveTablesMessage } from '~/util/storeHelpers/pragmaticLive'
import Vue from 'vue'

export const state = () => ({
  pragmaticLiveAvailableTableIdList: [],
  liveTablesMessages: {}, // { [tableId]: messageData }
})

export const mutations = {
  set_pragmaticLiveAvailableTableIdList(state, payload) {
    state.pragmaticLiveAvailableTableIdList = payload
  },
  addTo_liveTablesMessages(state, messages = {}) {
    Object.values(messages).forEach(message => Vue.set(state.liveTablesMessages, message.tableId, message))
  },
}

export const actions = {
  actSet_pragmaticLiveAvailableTableIdList({ commit }, { tableIdList }) {
    commit('set_pragmaticLiveAvailableTableIdList', tableIdList)
  },
  actAddTo_liveTablesMessages({ commit }, { messages }) {
    commit('addTo_liveTablesMessages', messages)
  },
}

export const getters = {
  get_pragmaticLiveAvailableTableIdList: (state) => state.pragmaticLiveAvailableTableIdList,
  get_liveTablesMessage: (state) => (tableId) => {
    const tableData = state.liveTablesMessages[tableId]
    if (!tableData) return {}
    return normalizeLiveTablesMessage(state.liveTablesMessages[tableId])
  },
}
